import React from "react";

function AppDialogBody({ inset = "default", className = "", children, ...rest }) {
  const classes = [
    "ds-dialog__body",
    inset === "none" ? "ds-dialog__body--inset-none" : "ds-dialog__body--inset-default",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

AppDialogBody.appDialogZone = "body";

export default AppDialogBody;
